import React from 'react';
import qs from 'query-string';

const SourceFileLink = ({ item }) => {
  const { fileName, sourceUrl } = item;

  const isFileNameFullPath = (fileName || '').includes('%');
  const sharePointItemName = isFileNameFullPath
    ? qs.parse(fileName).file
    : fileName;

  return (
    <a
      href={`${sourceUrl}?web=1`}
      target="_blank"
      rel="noopener noreferrer"
      className="external-source-link"
    >
      {sharePointItemName}
    </a>
  );
};

export default SourceFileLink;
